module.exports = __webpack_public_path__ + "img/steps4.4d922223.svg";